import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { global_get_array, global_get } from '@/utils';
import { config, cache } from '@/store';
import { useRoute, useRouter } from 'vue-router';

const __default__ = { name: 'bookmark' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['page', 'chapterId'],
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();

const props = __props;

let show = computed(() => {
	let page = props.page;

	if (route.name === 'double') {
		page = page * 2 - 1;
	}

	if (route.name === 'half') {
		page = Math.ceil(page / 2);
	}

	const bookmarkList = global_get_array('bookmarkList');
	const chapterId = props.chapterId;

	// 通过章节与页码判断书签展示
	for (let i = 0; i < bookmarkList.length; i++) {
		const item = bookmarkList[i];

		if (chapterId != item.chapterId) {
			continue;
		}
		
		if (item.page == page) {
			cache.bookmarkId = item.bookmarkId;
			config.bookmarkShow = true;
			return true;
		}

		// switch (config.browseType) {
		// 	case 'double':
		// 		if (item.page == page || item.page == page + 1) {
		// 			cache.bookmarkId = item.bookmarkId;
		// 			config.bookmarkShow = true;
		// 			return true;
		// 		}
		// 		break;
		// 	case 'half':
		// 		if (item.page == page || item.page == page + 1) {
		// 			cache.bookmarkId = item.bookmarkId;
		// 			config.bookmarkShow = true;
		// 			return true;
		// 		}
		// 		break;
		// 	default:
		// 		if (item.page == page) {
		// 			cache.bookmarkId = item.bookmarkId;
		// 			config.bookmarkShow = true;
		// 			return true;
		// 		}
		// 		break;
		// }
	}

	config.bookmarkShow = false;
	return false;
})

const __returned__ = { route, router, props, get show() { return show }, set show(v) { show = v } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})